<!--
 * @Description: 学生 详情
 * @Author: PF
 * @Date: 2023-11-30 09:51:50
 * @LastEditors: peifu
 * @LastEditTime: 2026-07-23 15:06:18
-->
<template>
  <div>
    <el-dialog class="wp80 hp80" :model-value="openDetail" :close-on-click-modal="false" :show-close="false" destroy-on-close>
      <template #header>
        <div class="header-left">
          <el-icon class="header-icon">
            <Document />
          </el-icon>
          <span class="header-title">详情-<span style="color:#797979">{{ ruleForm.xm }}</span></span>
        </div>
        <div class="header-right">
          <el-button type="info" text @click="closeWindow('openDetail', emits, false)">
            <el-icon>
              <Close />
            </el-icon>
          </el-button>
        </div>
      </template>
      <!-- 植保君34 -->
      <el-container class="hp100">
        <el-aside width="150px" style="text-align: center;">
          <el-image style="width: 100px; height: 100px; border-radius: 10px;" :src="baseUrl + ruleForm.zp" fit="cover" :preview-src-list="[baseUrl + ruleForm.zp]" :initial-index="0">
            <template #error>
              <div class="image-slot" style="background-color: #CDD0D6;">
                <el-icon :size="40" style="color: #fff" ><Avatar /></el-icon>
              </div>
            </template>
          </el-image>

          <ul class="menu-link mt10">
            <li v-for="(item, index) in menuList" :key="index" :class="menuIndex==index?'active':''" @click="menuIndex=index;menuName=item.children[0].name">{{item.name}}</li>
          </ul>
        </el-aside>
        <el-container>
          <el-header>
            <ul class="nav-pills">
              <li v-for="(item, index) in menuList[menuIndex].children" :key="index" :class="menuName==item.name?'active':''" @click="menuName=item.name">{{item.name}}</li>
            </ul>
          </el-header>
          <el-main>
            <jibenxinxi v-if="menuName === '基本信息'" :row="ruleForm" />
            <jiatingchengyuan v-if="menuName === '家庭成员'" :row="ruleForm" />
            <banjixinxi v-if="menuName === '班级信息'" :row="ruleForm" />
            <xueqipingyu v-if="menuName === '学期评语'" :row="ruleForm" />
            <chengjixinxi v-if="menuName === '成绩信息'" :row="ruleForm" />
            <jianglixinxi v-if="menuName === '奖励信息'" :row="ruleForm" />
            <chengchuxinxi v-if="menuName === '惩处信息'" :row="ruleForm" />
            <suohuozhengshu v-if="menuName === '所获证书'" :row="ruleForm" />
            <qingjiaxinxi v-if="menuName === '请假信息'" :row="ruleForm" />
            <kaoqinxinxi v-if="menuName === '考勤信息'" :row="ruleForm" />
            <xuejiyidong v-if="menuName === '学籍异动信息'" :row="ruleForm" />
            <shixijilu v-if="menuName === '实习记录'" :row="ruleForm" />
            <jiuyejilu v-if="menuName === '就业记录'" :row="ruleForm" />
            <jiaxiaolianxijilu v-if="menuName === '家校联系记录'" :row="ruleForm" />
            <gebiejiaoyujilu v-if="menuName === '个别教育记录'" :row="ruleForm" />
          </el-main>
        </el-container>
      </el-container>

    </el-dialog>
  </div>
</template>

<script setup>
import { defineEmits, defineProps, watch, ref } from 'vue'
import { loadData, closeWindow } from '@/api/common.js'
import jibenxinxi from './jibenxinxi.vue'
import jiatingchengyuan from './jiatingchengyuan.vue'
import banjixinxi from './banjixinxi.vue'
import xueqipingyu from './xueqipingyu.vue'
import chengjixinxi from './chengjixinxi.vue'
import jianglixinxi from './jianglixinxi.vue'
import chengchuxinxi from './chengchuxinxi.vue'
import zizhuxinxi from './zizhuxinxi.vue'
import suohuozhengshu from './suohuozhengshu.vue'
import qingjiaxinxi from './qingjiaxinxi.vue'
import kaoqinxinxi from './kaoqinxinxi.vue'
import xuejiyidong from './xuejiyidong.vue'
import shixijilu from './shixijilu.vue'
import jiuyejilu from './jiuyejilu.vue'
import sushexinxi from './sushexinxi.vue'
import liusuxinxi from './liusuxinxi.vue'
import xueshengfenxi from './xueshengfenxi.vue'
import gebiejiaoyujilu from './gebiejiaoyujilu.vue'
import jiaqiyaoshijilu from './jiaqiyaoshijilu.vue'
import jiaxiaolianxijilu from './jiaxiaolianxijilu.vue'
import xueshengkaoqin from './xueshengkaoqin.vue'
import zaixiaolvli from './zaixiaolvli.vue'

const props = defineProps({
  openDetail: { type: Boolean, required: true },
  row: { type: Object, required: false }
})
const emits = defineEmits(['update:openDetail'])

const xtszData = ref({ xsxq: {} })
const initXiTongSheZhi = () => {
  setTimeout(function () {
    xtszData.value = JSON.parse(sessionStorage.getItem('XITONGSHEZHI'))
  }, 600)
}
initXiTongSheZhi()

const menuIndex = ref(0)
const menuName = ref('基本信息')
const menuList = ref([
  { name: '基础信息', children: [{ name: '基本信息' }, { name: '家庭成员' }, { name: '班级信息' }] },
  { name: '学业与成长', children: [{ name: '学期评语' }, { name: '成绩信息' }, { name: '奖励信息' }, { name: '惩处信息' }, { name: '所获证书' }] },
  { name: '日常管理', children: [{ name: '请假信息' }, { name: '考勤信息' }, { name: '学籍异动信息' }] },
  { name: '实习与就业', children: [{ name: '实习记录' }, { name: '就业记录' }] },
  { name: '家校沟通', children: [{ name: '家校联系记录' }, { name: '个别教育记录' }] }
])

const activeName = ref(1)
const tabData = ref([
  { value: 1, name: '基本信息' },
  { value: 2, name: '家庭成员' },
  { value: 3, name: '班级信息' },
  { value: 4, name: '学期评语' },
  { value: 5, name: '成绩信息' },
  { value: 6, name: '奖励信息' },
  { value: 7, name: '惩处信息' },
  { value: 8, name: '资助信息' },
  { value: 9, name: '所获证书' },
  { value: 10, name: '请假信息' },
  { value: 11, name: '实习记录' },
  { value: 12, name: '就业记录' },
  { value: 13, name: '宿舍信息' },
  { value: 14, name: '留宿信息' },
  { value: 15, name: '学生分析' },
  { value: 16, name: '个别教育记录' },
  { value: 17, name: '假期要事记录' },
  { value: 18, name: '家校联系记录' },
  { value: 19, name: '学生考勤' },
  { value: 20, name: '在校履历' }
])
const tabDataBuFen = ref([
  { value: 1, name: '基本信息' },
  { value: 2, name: '家庭成员' },
  { value: 3, name: '班级信息' },
  { value: 4, name: '学期评语' },
  { value: 6, name: '奖励信息' },
  { value: 7, name: '惩处信息' },
  { value: 8, name: '资助信息' },
  { value: 10, name: '请假信息' },
  { value: 13, name: '宿舍信息' },
  { value: 14, name: '留宿信息' },
  { value: 16, name: '个别教育记录' },
  { value: 18, name: '家校联系记录' },
  { value: 20, name: '在校履历' }
])

const handleChange = (val) => {
  activeName.value = val
}

const baseUrl = ref()
const ruleForm = ref({ jtxx: {}, xsly: {}, xsxj: {} })
watch(
  () => props.openDetail,
  () => {
    if (props.openDetail) {
      baseUrl.value = process.env.VUE_APP_BASE_API
      loadData({ url: '/api/v2/pdp/xuesheng/' + props.row.xsid, ruleForm })
    }
  },
  { deep: true, immediate: true }
)
</script>
<style lang="less" scoped>
:deep(.el-tabs__content) {
  display: none;
}
.nei-rong {
  height: calc(100% - 55px);
  overflow: auto;
  padding: 10px;
  :deep(.el-descriptions) {
    margin-bottom: 20px;
  }
}
.menu-link {
  li {
    color: #909399;
    font-weight: 500;
    font-size: 15px;
    border-radius: 10px;
    padding: 10px 20px;
    margin: 5px;
    cursor: pointer;
  }
  li:hover {
    background-color: #f4f4f5;
  }
  li.active {
    color: #626aef;
    background-color: #626aef29;
  }
}
.nav-pills {
  display: flex;
  li {
    color: #909399;
    font-weight: 500;
    font-size: 15px;
    border-radius: 10px;
    padding: 8px 20px;
    margin: 5px;
    cursor: pointer;
  }
  li:hover {
    color: #626aef;
  }
  li.active {
    color: #fff;
    background-color: #626aef;
  }
}
</style>
